import { Avatar } from '@seek/avatar';

import { TextSkeleton } from 'src/libs/TextSkeleton';

import { JobApplicationCardLayout } from '../JobApplicationCardLayout';

export const JobApplicationCardSkeleton = () => (
  <JobApplicationCardLayout
    avatarCheckBox={<Avatar size="large" variant="icon" name="" loading />}
    fullNameAndCertifiedIcon={<TextSkeleton width="50%" height="medium" />}
    recentRoleAndTenure={<TextSkeleton width="40%" height="small" />}
    keyInfo={<TextSkeleton width="30%" height="small" />}
    badges={<TextSkeleton width="30%" height="small" />}
    roleRequirementsDisclosure={<TextSkeleton width="40%" height="medium" />}
    matchedSkillsDisclosure={<TextSkeleton width="30%" height="medium" />}
    appliedDate={<TextSkeleton width="20%" height="small" />}
    attachmentsAndRecords={<TextSkeleton width="40%" height="medium" />}
    actionButtons={<TextSkeleton width="30%" height="medium" />}
    priorityApplyBadge={<TextSkeleton width="20%" height="small" />}
  />
);
